import React from 'react';
import { useNavigate } from 'react-router-dom';
import {
  Container,
  Grid,
  Paper,
  Typography,
  Button,
  Box,
  Card,
  CardContent,
} from '@mui/material';
import {
  Feedback as FeedbackIcon,
  History as HistoryIcon,
} from '@mui/icons-material';

const Dashboard = () => {
  const navigate = useNavigate();

  const features = [
    {
      title: 'Generate Feedback',
      description: 'Submit student homework and receive AI-generated feedback.',
      icon: <FeedbackIcon sx={{ fontSize: 40 }} />,
      path: '/feedback',
    },
    {
      title: 'View History',
      description: 'Access past feedback submissions and responses.',
      icon: <HistoryIcon sx={{ fontSize: 40 }} />,
      path: '/history',
    },
  ];

  return (
    <Container maxWidth="lg">
      <Typography variant="h4" component="h1" gutterBottom>
        Welcome to Eduson LLM
      </Typography>

      <Grid container spacing={3}>
        {features.map((feature) => (
          <Grid item xs={12} md={6} key={feature.title}>
            <Card
              sx={{
                height: '100%',
                display: 'flex',
                flexDirection: 'column',
                cursor: 'pointer',
                '&:hover': {
                  boxShadow: 6,
                },
              }}
              onClick={() => navigate(feature.path)}
            >
              <CardContent>
                <Box
                  sx={{
                    display: 'flex',
                    flexDirection: 'column',
                    alignItems: 'center',
                    textAlign: 'center',
                  }}
                >
                  <Box sx={{ color: 'primary.main', mb: 2 }}>
                    {feature.icon}
                  </Box>
                  <Typography variant="h6" component="h2" gutterBottom>
                    {feature.title}
                  </Typography>
                  <Typography color="text.secondary">
                    {feature.description}
                  </Typography>
                </Box>
              </CardContent>
            </Card>
          </Grid>
        ))}
      </Grid>

      <Paper sx={{ p: 3, mt: 4 }}>
        <Typography variant="h6" gutterBottom>
          Quick Start Guide
        </Typography>
        <Typography paragraph>
          1. Navigate to the "Generate Feedback" section to submit student homework.
        </Typography>
        <Typography paragraph>
          2. Enter the student's name and paste their homework text.
        </Typography>
        <Typography paragraph>
          3. Click "Generate Feedback" to receive AI-powered feedback.
        </Typography>
        <Typography paragraph>
          4. View past submissions and feedback in the "History" section.
        </Typography>
      </Paper>
    </Container>
  );
};

export default Dashboard; 